import styled from "styled-components";

export const FlexContainer = styled.div`
    display: flex;
    ${props => props.vertical && `flex-direction: column`};
    ${props => props.gap && `gap: ${typeof props.gap === "number" ? `${props.gap}px` : props.gap}`};
    ${props => props.justify && `justify-content: ${props.justify}`};
    ${props => props.align && `align-items: ${props.align}`};
    ${props => props.wrap && `flex-wrap: ${Boolean(props.wrap) ? "wrap" : props.wrap}`};
    ${props => props.flex && `flex: ${typeof props.flex === "boolean" ? 1 : props.flex}`};
    ${props => props.fullWidth && `width: 100%`};
    ${props =>
        props.minWidth &&
        `min-width: ${
            typeof props.minWidth === "number" ? `${props.minWidth}px` : props.minWidth
        }`};
    ${props =>
        props.maxWidth &&
        `max-width: ${
            typeof props.maxWidth === "number" ? `${props.maxWidth}px` : props.maxWidth
        }`};
    ${props => props.marginBottom && `margin-bottom: ${props.marginBottom}`};
    ${props => props.marginTop && `margin-top: ${props.marginTop}`};
    ${props => props.backgroundColor && `background-color: ${props.backgroundColor}`};
`;
